import React, { Component } from 'react';
import { ErrorPage } from '@everfi/reactifi';
import i18n from './i18n';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // render fallback UI
      const errorMessage = (
        <React.Fragment>
          {i18n.t("Please try to refresh this page. If that doesn't work you can go to ")}
          <a href="https://everfihelp.force.com/foundry/s/" target="_blank" rel="noopener noreferrer">
            {i18n.t('this page')}
          </a>{' '}
          {i18n.t('for help.')}
        </React.Fragment>
      );

      return <ErrorPage errors={[errorMessage]} title={i18n.t('Something Went Wrong.')} />;
    }

    // when there's not an error, render children untouched
    return this.props.children;
  }
}
